import React from "react";
import { ArrowUpRightFromSquare } from "lucide-react";

const works = [
  {
    title: "Social Media App",
    description:
      "The app connect you to the talented people around the world.",
    image: "/images/landscape-1.png",
    link: "#",
  },
  {
    title: "Music App",
    description:
      "The app connect you to the talented people around the world.",
    image: "/images/landscape-2.png",
    link: "#",
  },
  {
    title: "Online Shopping App",
    description:
      "The app connect you to the talented people around the world.",
    image: "/images/landscape-3.png",
    link: "#",
  },
];

export default function PortfolioSection() {
  return (
    <section id="portfolio" className="py-12 text-white">
      <div className="container mx-auto flex flex-col items-center justify-center px-4">
        <h1 className="text-3xl font-bold">My Work</h1>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 justify-center place-items-center mx-auto max-w-5xl">
          {works.map((work, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl w-80 h-96"
            >
              <div className="flex items-center justify-center w-full h-full transition-opacity duration-500 group-hover:opacity-0">
                <span className="text-3xl md:text-4xl font-extrabold text-center w-full break-words px-4">
                  {work.title}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 flex h-0 w-full flex-col items-center justify-center overflow-hidden rounded-xl bg-gradient-to-t from-[#26658C] to-black/60 px-10 text-center text-sm transition-all duration-500 group-hover:h-full">
                <h3 className="mb-5 text-lg font-medium">
                  {work.title}
                </h3>
                <p>{work.description}</p>
                <a
                  href={work.link}
                  className="mt-5 flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#26658C]"
                >
                  <ArrowUpRightFromSquare size={20} />
                </a>
              </div>
            </div>
          ))}
        </div>

        <a
          href="#"
          className="mx-auto mt-12 inline-block rounded-md border border-[#26658C] px-12 py-3 transition-colors duration-500 hover:bg-[#26658C] hover:text-white"
        >
          See more
        </a>
      </div>
    </section>
  );
}
